module.exports = __webpack_public_path__ + "static/img/bg_home_getbids.e2585db0.png";